<template>
    <div class="progress-bar d-flex flex-row">
        <div
            key="p-1"
            class="progress-bar__full"
            :class="progress === 100 ? `progress-bar__full--border progress-bar-${colorVariant}--active` : `progress-bar-${colorVariant}--active`"
            :style="progressWidth.full"
        ></div>
        <div
            key="p-2"
            class="progress-bar__empty"
            :class="progress === 0 ? `progress-bar__full--border progress-bar-${colorVariant}--inactive` : `progress-bar-${colorVariant}--inactive`"
            :style="progressWidth.empty"
        ></div>
    </div>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

export default {
    name: 'progressBar',
    mixins: [colorVariantMixin],
    props: {
        progress: {
            type: Number
        }
    },
    computed: {
        progressWidth() {
            return {
                full: { width: this.progress + '%' },
                empty: { width: 100-this.progress + '%' }
            } 
        },
    },
}
</script>
<style lang="scss">
    .progress-bar {
        height: 10px;
        @media screen and (min-width: 992px) {
            height: 12px;
        }
        background-color: #FFF;
    }
    .progress-bar__full {
        transition: width 0.3s ease-in-out;
        border-radius: 25px 0 0 25px;
    }

    .progress-bar__empty {
        transition: width 0.3s ease-in-out;
        background-color: #EEE;
        border-radius: 0 25px 25px 0;
    }

    .progress-bar__full--border {
        border-radius: 25px;
    }
</style>